import { FunctionComponent, useContext, useEffect, useState } from 'react';
import clsx from 'clsx';

// MUI
import { styled } from '@mui/material/styles';

// OpenLayers
import Rotate from 'ol/control/Rotate';
import { MapEvent } from 'ol';

// Custom components
import MapContext from '@/components/Map/MapContext';
import { registerOlControl } from '@/lib/olHelpers';
import makeMUIControlStyle from '../makeMUIControlStyle';

// Types
import { MapContextType } from '@/@types/context/MapContext';
import { IRotateControl } from '@/@types/components/Map/Controls/OpenLayers';

const sjeverIcon = `
<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 x="0px" y="0px" width="45%" height="45%" viewBox="0 0 24 48" enableBackground="new 0 0 24 48" xml:space="preserve">
<polygon points="17.72,23 12.948,8.684 11.052,8.684 6.28,23"/>
<polygon points="15.613,25 12,35.838 8.387,25 6.28,25 11.052,39.316 12.948,39.316 17.72,25"/>
</svg>`;

// Custom Rotate control class
class CustomRotateControl extends Rotate {
  render(mapEvent: MapEvent) {
    super.render(mapEvent);

    const compass = this.element.querySelector('.ol-compass');
    // Replace the default ASCII arrow with your custom SVG
    if (compass) {
      compass.innerHTML = sjeverIcon;
    }
  }
}

const RotateControl: FunctionComponent<IRotateControl> = (props) => {
  const context = useContext(MapContext) as MapContextType;

  const [isControlAdded, setIsControlAdded] = useState(false);

  const options = {
    className: undefined,
    label: undefined,
    tipLabel: undefined,
    duration: undefined,
    autoHide: undefined,
    render: undefined,
    resetNorth: undefined,
    target: undefined,
  };

  const events = {
    change: undefined,
    error: undefined,
    propertychange: undefined,
  };

  useEffect(() => {
    if (!isControlAdded) {
      const overriddenProps: any = {
        ...props,
        className: clsx(props.className, 'ol-rotate'),
      };

      // Use the custom control class instead of the default Rotate
      registerOlControl(context, CustomRotateControl, overriddenProps, options, events);

      setIsControlAdded(true);
    }
  }, [
    context,
    props.className,
    props.label,
    props.tipLabel,
    props.duration,
    props.autoHide,
    props.render,
    props.resetNorth,
    props.target,
    isControlAdded,
  ]);

  return null;
};

const StyledRotateControl = styled(RotateControl)(({ theme }) => {
  const styles = makeMUIControlStyle(theme);
  return {
    ...styles.control,
    button: {
      backgroundColor: theme.palette.primary.main,
      height: '1.75em',
      width: '1.75em',
    },
  };
});

export default StyledRotateControl;
